// extracted by mini-css-extract-plugin
export default {"root":"PermissionsView_root__uDWdy","panel":"PermissionsView_panel__0YpGs","subTitle":"PermissionsView_subTitle__AEu6u","description":"PermissionsView_description__o1GhH"};